// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.888 12.344a.498.498 0 0 1-.32.456l-.929.341c-.936.344-1.602 1.273-1.602 2.359 0 1.38 1.075 2.5 2.4 2.5h12.96c2.121 0 3.84-1.79 3.84-4s-1.719-4-3.84-4c-.183 0-.362.013-.537.038l-1.009.147a.475.475 0 0 1-.492-.266l-.469-.942C14.01 7.204 12.237 6 10.197 6 7.34 6 5.011 8.366 4.92 11.319zM17.398 8c3.18 0 5.76 2.686 5.76 6s-2.58 6-5.76 6H4.437c-2.387 0-4.32-2.015-4.32-4.5 0-1.9 1.13-3.526 2.73-4.185a.265.265 0 0 0 .16-.232C3.216 7.135 6.355 4 10.198 4c2.724 0 5.095 1.576 6.318 3.901a.25.25 0 0 0 .248.135c.208-.024.42-.036.633-.036z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceCloud;
